export const UPDATE_PAGINATION_PAGE = 'UPDATE_PAGINATION_PAGE';

export const UPDATE_PAGINATION_ROWS_PER_PAGE =
  'UPDATE_PAGINATION_ROWS_PER_PAGE';

export const RESET_PAGINATION = 'RESET_PAGINATION';

export const RESET_ALL_PAGINATION = 'RESET_ALL_PAGINATION';
